/**
 * Queue drain must not treat "no error flag" as success.
 *
 * useRest clears errors at the start of execute. If the request throws
 * before those errors are populated (headers, aborted fetch, empty 2xx
 * body), hasErrors stays false. Dequeueing on that signal drops
 * transactions / level nodes / hardware histories that never reached
 * the server.
 */
export function offlineCreateReachedServer (state: {
  hasErrors: boolean
  responseData: unknown
}): boolean {
  return state.hasErrors === false && state.responseData != null
}
